export default "__VITE_ASSET__a494ff3d__"